import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const points = [
  '10',
  '1.86321757',
  '8.10810809',
  '0',
  '0',
  '7.98521826',
  '8.10810809',
  '15.9704364',
  '10',
  '14.1072189',
  '3.78378374',
  '7.98521826',
].join(' ');

const transforms = {
  up: 'translate(8, 0) rotate(90 4 4)',
  right: 'translate(8, 8) rotate(180 4 4)',
  down: 'translate(0, 8) rotate(270 4 4)',
  left: 'translate(0, 0) rotate(0 4 4)',
};

const Svg = styled.svg`
  width: ${(props) => props.style.width || '1rem'};
  height: ${(props) => props.style.height || 'auto'};
  fill: ${(props) => props.style.fill || '#000'};
`;

const Chevron = ({ style, className, direction }) => (
  <Svg style={style} className={className} viewBox="0 0 16 16">
    <polygon points={points} transform={transforms[direction]} />
  </Svg>
);

Chevron.defaultProps = {
  style: {},
  className: undefined,
  direction: 'left',
};

Chevron.propTypes = {
  direction: PropTypes.oneOf(['up', 'right', 'down', 'left']),
  className: PropTypes.string,
  style: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
  }),
};

export default Chevron;
